import React from "react";
import AppBar from "@mui/material/AppBar";

import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import appIcon from "./core/assets/images/appIcon.png";
import HelpDialog from "./components/Dialogs/HelpDialog";
import DefinitionDialog from "./components/Dialogs/DefinitionDialog";
import SearchDialog from "components/Dialogs/SearchDialog";
import ImageCacheDialog from "components/Dialogs/ImageCacheDialog";

const HeaderBar = ({ setSelectedNuclide }) => {
  return (
    <AppBar color="primary" position="static">
      <Toolbar
        sx={{
          height: "50px !important",
          minHeight: "unset !important",
          padding: "0 !important",
          paddingLeft: "5px !important",
        }}
      >
        <img src={appIcon} alt="logo" />
        <Typography lineHeight={1} variant="h6" flexGrow="1" ml="0.5em">
          Interactive Isotopes App
        </Typography>

        <SearchDialog setSelectedNuclide={setSelectedNuclide} />
        <DefinitionDialog />
        <HelpDialog />
        <ImageCacheDialog />
      </Toolbar>
    </AppBar>
  );
};

export default React.memo(HeaderBar);
